(function() {
  var UPSELL_LIMIT = 2;
  var upsellProductsCache = null;
  var lastFetchedProductId = null;
  var isFetching = false;
  var isDrawerDismissed = false;
  var renderTimer = 0;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getUpsellContainer() {
    return document.getElementById('CartDrawer-Upsell');
  }

  function getFirstCartProductId() {
    var container = getUpsellContainer();
    if (!container) return null;
    var id = container.getAttribute('data-first-product-id');
    return id && id.trim() !== '' ? id.trim() : null;
  }

  function getRenderedProductId() {
    var container = getUpsellContainer();
    return container ? container.getAttribute('data-upsell-rendered-for') : null;
  }

  function hasRenderedUpsells() {
    var container = getUpsellContainer();
    var products = container && container.querySelector('.cart-drawer-upsell__products');
    return !!(products && products.children.length);
  }

  function renderUpsellProducts(products, productId) {
    var container = getUpsellContainer();
    if (!container) return;

    if (!products || products.length === 0) {
      container.innerHTML = '';
      container.removeAttribute('data-upsell-rendered-for');
      return;
    }

    var html = '<p class="cart-drawer-upsell__heading">Vous aimerez aussi</p>';
    html += '<div class="cart-drawer-upsell__products">';

    products.forEach(function(product) {
      var availableVariants = product.variants.filter(function(variant) { return variant.available; });
      var firstAvailable = availableVariants.length ? availableVariants[0] : product.variants[0];
      var imageUrl = product.featured_image || '';
      var image = imageUrl.indexOf('?') > -1 ? imageUrl + '&width=200' : imageUrl + '?width=200';
      var hasVariants = availableVariants.length > 1;
      var title = product.title.replace(/"/g, '&quot;');
      var priceHtml = firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price
        ? '<s>' + formatMoney(firstAvailable.compare_at_price) + '</s> ' + formatMoney(firstAvailable.price)
        : formatMoney(firstAvailable.price);

      html += '<div class="cart-drawer-upsell__product">';
      html += '<img class="cart-drawer-upsell__product-image" src="' + image + '" alt="' + title + '" loading="lazy">';
      html += '<a href="' + product.url + '" class="cart-drawer-upsell__product-title">' + product.title + '</a>';
      html += '<span class="cart-drawer-upsell__product-price" data-upsell-price="' + product.id + '">' + priceHtml + '</span>';

      if (hasVariants) {
        html += '<select class="cart-drawer-upsell__variant-select" data-upsell-variant-select="' + product.id + '" aria-label="Variante pour ' + title + '">';
        availableVariants.forEach(function(variant) {
          var selected = variant.id === firstAvailable.id ? ' selected' : '';
          html += '<option value="' + variant.id + '" data-price="' + variant.price + '" data-compare-price="' + (variant.compare_at_price || '') + '"' + selected + '>' + variant.title + '</option>';
        });
        html += '</select>';
      }

      html += '<button class="cart-drawer-upsell__add-btn" data-upsell-add="' + product.id + '" data-variant-id="' + firstAvailable.id + '" type="button">Ajouter au panier</button>';
      html += '</div>';
    });

    html += '</div>';
    container.innerHTML = html;
    container.setAttribute('data-upsell-rendered-for', productId);
    bindUpsellEvents();
  }

  function fetchAndRenderUpsells(productId, force) {
    if (!productId) {
      var emptyContainer = getUpsellContainer();
      if (emptyContainer) emptyContainer.innerHTML = '';
      return;
    }

    if (!force && productId === getRenderedProductId() && hasRenderedUpsells()) return;

    if (!force && productId === lastFetchedProductId && upsellProductsCache) {
      renderUpsellProducts(upsellProductsCache, productId);
      return;
    }

    if (isFetching) return;
    isFetching = true;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (UPSELL_LIMIT + 2) + '&intent=related')
      .then(function(response) { return response.json(); })
      .then(function(data) {
        isFetching = false;
        var products = (data.products || []).slice(0, UPSELL_LIMIT);
        lastFetchedProductId = productId;
        upsellProductsCache = products;
        renderUpsellProducts(products, productId);
      })
      .catch(function(error) {
        isFetching = false;
        console.error('Cart upsell fetch error:', error);
      });
  }

  function queueUpsellRender(force) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(function() {
      var drawer = getCartDrawer();
      if (!drawer || !drawer.classList.contains('active')) return;
      fetchAndRenderUpsells(getFirstCartProductId(), force);
    }, 100);
  }

  function bindUpsellEvents() {
    var container = getUpsellContainer();
    if (!container) return;

    container.querySelectorAll('[data-upsell-variant-select]').forEach(function(select) {
      select.addEventListener('change', function() {
        var productId = this.dataset.upsellVariantSelect;
        var option = this.options[this.selectedIndex];
        var button = container.querySelector('[data-upsell-add="' + productId + '"]');
        var price = parseInt(option.dataset.price, 10);
        var comparePrice = option.dataset.comparePrice ? parseInt(option.dataset.comparePrice, 10) : null;

        if (button) button.dataset.variantId = this.value;

        var priceElement = container.querySelector('[data-upsell-price="' + productId + '"]');
        if (priceElement) {
          priceElement.innerHTML = comparePrice && comparePrice > price
            ? '<s>' + formatMoney(comparePrice) + '</s> ' + formatMoney(price)
            : formatMoney(price);
        }
      });
    });

    container.querySelectorAll('[data-upsell-add]').forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(this.dataset.variantId, this);
      });
    });
  }

  function resetUpsellButton(button, text) {
    button.textContent = text;
    button.disabled = false;
  }

  function showUpsellAddError(button, text, message) {
    button.textContent = message;
    window.setTimeout(function() {
      resetUpsellButton(button, text);
    }, 2500);
  }

  function addToCart(variantId, button) {
    var parsedVariantId = parseInt(variantId, 10);
    var originalText = button.textContent;

    if (!parsedVariantId) {
      showUpsellAddError(button, originalText, 'Indisponible');
      return;
    }

    button.disabled = true;
    button.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parsedVariantId, quantity: 1 }] })
    })
      .then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(payload) {
          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Impossible d’ajouter ce produit au panier.');
          }
          return payload;
        });
      })
      .then(function() {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        return fetch(root + 'cart.js').then(function(response) {
          if (!response.ok) throw new Error('Impossible de vérifier le panier.');
          return response.json();
        });
      })
      .then(function(cart) {
        var isAdded = cart.items && cart.items.some(function(item) {
          return String(item.variant_id) === String(parsedVariantId) && item.quantity > 0;
        });
        if (!isAdded) throw new Error('Le produit n’a pas été ajouté au panier.');
        resetUpsellButton(button, originalText);
        refreshCartDrawer();
      })
      .catch(function(error) {
        console.error('Upsell add to cart error:', error);
        showUpsellAddError(button, originalText, error.message || 'Indisponible');
      });
  }

  function refreshCartDrawer() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(root + 'cart?section_id=cart-drawer')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var newDrawerInner = documentFragment.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
        var newBubble = documentFragment.getElementById('cart-icon-bubble');
        var currentBubble = document.getElementById('cart-icon-bubble');
        var drawer = getCartDrawer();

        if (newDrawerInner && currentDrawerInner) currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
        if (drawer) drawer.classList.toggle('is-empty', !!documentFragment.querySelector('cart-drawer-items.is-empty'));

        queueUpsellRender(true);
      })
      .catch(function(error) {
        console.error('Cart drawer refresh error:', error);
      });
  }

  function patchDrawerBehavior() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.dataset.upsellDismissGuard === 'true') return;
    if (typeof drawer.open !== 'function' || typeof drawer.close !== 'function') return;

    var originalOpen = drawer.open;
    var originalClose = drawer.close;

    drawer.open = function(triggeredBy) {
      if (isDrawerDismissed && !triggeredBy) return;
      return originalOpen.apply(this, arguments);
    };

    drawer.close = function() {
      isDrawerDismissed = true;
      return originalClose.apply(this, arguments);
    };

    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      cartLink.addEventListener('click', function() {
        isDrawerDismissed = false;
      }, true);
    }

    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (form && form.matches('form[data-type="add-to-cart-form"]')) isDrawerDismissed = false;
    }, true);

    drawer.dataset.upsellDismissGuard = 'true';
  }

  function watchDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!drawer.classList.contains('active')) continue;
        if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'class') {
          queueUpsellRender(false);
          return;
        }
        if (mutations[i].type === 'childList') {
          var products = getUpsellContainer() && getUpsellContainer().querySelector('.cart-drawer-upsell__products');
          if (!products || !products.children.length) {
            queueUpsellRender(false);
            return;
          }
        }
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  function subscribeToCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      queueUpsellRender(false);
    });
  }

  function setup() {
    patchDrawerBehavior();
    watchDrawer();
    subscribeToCartUpdate();
  }

  if (document.readyState === 'complete') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', setup);
  }
})();
